export const getPipelineName = (pipeline, isEndorsement) => {
	if (!pipeline?.id) {
		return '';
	}

	const isNewBusiness = pipeline.id === process.env.REACT_APP_PIPELINE_NEW_BUSINESS;
	const isDebtor = pipeline.id === process.env.REACT_APP_PIPELINE_DEBTORS;

	if (isEndorsement) {
		return 'Endorsement';
	} else if (isNewBusiness) {
		return pipeline.label;
	} else if (isDebtor) {
		return 'Debtor';
	} else {
		return pipeline?.label?.slice(0, -1) ?? 'Unknown';
	}
};
